// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3Zzd0","legacyBtn":"MutateMid_legacyBtn__1sPF7"};